import Autorenew from "@mui/icons-material/Autorenew";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { NewCampaign } from "./New";
import { Table } from "../../components/Table";
import { listInsights } from "../../services/insights";
import { queryClient } from "../../services/queryClient";
import { Insights } from "../../types/insights";
import { useStyles } from "./styles";
import { NewCampaignFile } from "./NewFile";
import { DialogSuccessCampaign } from "../../components/DialogSuccessCampaign";
import { MenuButton } from "../../components/MenuButton";
import MenuItem from "@mui/material/MenuItem";

export function CreateCampaign() {
  const navigate = useNavigate();
  const styles = useStyles();

  const [insight, setInsight] = useState<Insights | null>(null);
  const [dialogNewCampaign, setDialogNewCampaign] = useState<boolean>(false);
  const [dialogNewCampaignFile, setDialogNewCampaignFile] =
    useState<boolean>(false);
  const [dialogSuccesCampaign, setDialogSuccessCampaign] =
    useState<boolean>(false);

  const handleGoToHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const insights: any = useQuery("insights", listInsights);

  const filter = () => {
    let list = [];
    new Promise(function (myResolve, myReject) {
      for (let i = 0; i < insights.data?.length; i++) {
        if (insights.data[i].not_show !== 1) {
          list.push(insights.data[i]);
        }
      }
    });

    return list;
  };

  const invalidateInsights = useCallback(() => {
    queryClient.invalidateQueries("insights");
  }, []);

  const handleChangeInsight = useCallback((item: Insights | null) => {
    setDialogNewCampaign((prev) => !prev);
    setInsight(item);
  }, []);

  const handleDialogNewCampaignFile = useCallback(() => {
    setDialogNewCampaignFile((prev) => !prev);
  }, []);

  const handleDialogSuccessCampaign = useCallback(() => {
    setDialogSuccessCampaign((prev) => !prev);
  }, []);

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Criar disparo em canais digitais</Typography>
        <Typography variant="body2">
          Suas audiências criadas estão disponíveis para realizar qualquer tipo
          de ação.
        </Typography>
      </div>
      <div className={styles.rootActions}>
        <Button variant="contained" onClick={handleGoToHome}>
          Criar audiência
        </Button>
        <MenuButton
          id="btn-apps"
          className={styles.btnOptions}
          variant="outlined"
          label="Mais opções"
        >
          <MenuItem onClick={handleDialogNewCampaignFile}>
            Importar arquivos
          </MenuItem>
          <MenuItem onClick={() => navigate("/blacklist")}>Blacklist</MenuItem>
          <MenuItem onClick={() => navigate("/answers")}>Respostas</MenuItem>
          <MenuItem onClick={() => navigate("/templates")}>Templates</MenuItem>
        </MenuButton>
        <Tooltip title="Atualizar lista" placement="top">
          <IconButton
            onClick={invalidateInsights}
            className={styles.btnPutList}
          >
            <Autorenew />
          </IconButton>
        </Tooltip>
      </div>
      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          search
          data={filter() as []}
          isLoading={insights.isFetching}
          columns={[
            { title: "Nome", field: "nameList" },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Button
                  disabled={row.processado === 0}
                  variant="text"
                  onClick={() => {
                    handleChangeInsight(row);
                  }}
                >
                  {row.processado === 0
                    ? "Importando audiência"
                    : "Iniciar disparo"}
                </Button>
              ),
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 10,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
        />
      </Paper>
      <NewCampaign
        insight={insight as Insights}
        open={dialogNewCampaign}
        onSuccess={handleDialogSuccessCampaign}
        onClose={() => {
          handleChangeInsight(null);
        }}
      />
      <NewCampaignFile
        open={dialogNewCampaignFile}
        onClose={handleDialogNewCampaignFile}
      />
      <DialogSuccessCampaign
        open={dialogSuccesCampaign}
        onClose={handleDialogSuccessCampaign}
      />
    </>
  );
}
